import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'; 
import CustomerModel from "./models/CustomerModel";
import FinanceRegisterModal from "./CustomerModal";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";
import { logAuditEvent } from '../../utils/auditLogger';

function CustomerGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [customerModel, setCustomerModel] = useState(new CustomerModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);

  function closeModal() {
    setIsOpen(false);
    setCustomerModel(new CustomerModel());
    props.fetchCustomers();
  }

  const rows = props.CustomerData
    ? props.CustomerData.filter(
      (item) =>
        (item.CustomerName &&
          item.CustomerName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.MobileNumber &&
          item.MobileNumber.toString().toLowerCase().includes(filterText.toLowerCase())) ||
        (item.EmailId &&
          item.EmailId.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    setCustomerModel(row);
    setIsOpen(true);
    setActionType(name);
    try {
      const moduleName = props.moduleName || 'Customer';
      const details = JSON.stringify({ CustomerId: row?.CustomerId, CustomerName: row?.CustomerName });
      const actionLabel = name === 'View' ? 'View Button Click' : name === 'Edit' ? 'Edit Button Click' : name === 'Delete' ? 'Delete Button Click' : name;
      logAuditEvent(moduleName, actionLabel, details);
    } catch (e) {
      // non-blocking
    }
  };
  async function onSubmit(e, data) {
    const customerModel = data;
    if (e.target.name === "Edit") {
      let customerDetails = {
        CustomerId: customerModel.CustomerId,
        CustomerName: customerModel.CustomerName,
        Occupation: customerModel.Occupation ? customerModel.Occupation : "",
        MobileNumber: customerModel.MobileNumber,
        EmailId: customerModel.EmailId,
        AddressLine1: customerModel.AddressLine1,
        AddressLine2: customerModel.AddressLine2,
        AddressLine3: customerModel.AddressLine3,
        City: customerModel.City,
        State: customerModel.State,
        Country: customerModel.Country,
        PinNumber: customerModel.PinNumber,
        OfficeAddressLine1: customerModel.OfficeAddressLine1,
        OfficeAddressLine2: customerModel.OfficeAddressLine2,
        OfficeAddressLine3: customerModel.OfficeAddressLine3,
        OfficeCity: customerModel.OfficeCity,
        OfficeState: customerModel.OfficeState,
        OfficeCountry: customerModel.OfficeCountry,
        OfficePinNumber: customerModel.OfficePinNumber,
        Reference1Name: customerModel.Reference1Name,
        Reference1MobileNumber: customerModel.Reference1MobileNumber,
        Reference2Name: customerModel.Reference2Name,
        Reference2MobileNumber: customerModel.Reference2MobileNumber,
        AnualIncome: customerModel.AnualIncome,
        FamilyMemberName: customerModel.FamilyMemberName,
        FamilyMemberMobileNumber: customerModel.FamilyMemberMobileNumber,
        DOB: customerModel.DOB,
        UserId: getStorageValues('userId')
      };
      if (validation(customerDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/customer/save", 
            customerDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchCustomers();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else if(e.target.name === "Delete"){
      let customerDetails = {
        CustomerId: customerModel.CustomerId,
        UserId: getStorageValues('userId')
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/customer/delete", customerDetails
        );
        if (response.status === 200) {
          CreateAlert("Customer deleted successfully!!", "Success", setAlert);
          props.fetchCustomers();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  function validation(customerDetails) {
    var validation = true;
    if (customerDetails) {
      if (!customerDetails.CustomerName || customerDetails.CustomerName.length === 0) {
        CreateAlert("Please enter customer name!!", "Warning", setAlert);
          validation = false;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      return (validation = false);
    }
    return validation;
  }

  const columns = [
    {
      name:<div className="titlename"><span>Customer </span></div> ,
      selector: row => row.CustomerName,
      cell: (row) => (
        <span title={row.CustomerName}>{row.CustomerName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Mobile </span></div>,
      selector: row => row.MobileNumber,
      cell: (row) => (
        <span title={row.MobileNumber}>{row.MobileNumber}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Email </span></div>,
      selector: row => row.EmailId,
      cell: (row) => (
        <span title={row.EmailId}>{row.EmailId}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
  ];
  if(props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1){
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
            props.UserPermissions.ViewModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "View");
                }}
              >
                <Icons.Eye data-feather="eye" className="action-eye" />
              </Link>
            : null
          }
          {
            props.UserPermissions.EditModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Edit");
                }}
              >
                <Icons.Edit data-feather="edit" className="feather-edit" />
              </Link>
            : null
          }
          {
            props.UserPermissions.DeleteModule === 1 ? 
              <Link
                className="confirm-text p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Delete");
                }}
              >
                <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
              </Link>
            : null
          }
        </div>
      ),
      center: "true",
      width: "150px"
    },);
  };

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="CustomerName"
            sortIcon={<SortArrow/>}
            persistTableHead={true}
          />
        </div>
      </div>
      <FinanceRegisterModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={customerModel}
        onSubmit={onSubmit}
      />
    </>
  );
}

export default CustomerGrid;
